module.exports = __webpack_public_path__ + "img/connect.ead06c01.svg";